import React, { useState, useEffect, useCallback, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Header from "./Header";
import { FaArrowUp, FaTimes, FaBars, FaChevronDown, FaChevronUp, FaYoutube } from "react-icons/fa";
import "@fortawesome/fontawesome-free/css/all.min.css";
import CrackersLoader from "./CrackersLoader";
import "./quick.css";

// Helper function to round to nearest whole number
const roundToNearestRupee = (amount) => {
  return Math.round(amount);
};

// Tag color mapping
const getTagColor = (tag) => {
  const tagColors = {
    'new': { bg: '#038208', text: '#FFFFFF', label: 'New' },
    'best_seller': { bg: '#df0496', text: '#FFFFFF', label: 'Best Seller' },
    'most_ordered': { bg: 'rgb(4, 63, 190)', text: '#FFFFFF', label: 'Most Ordered' },
    'limited_edition': { bg: '#9C27B0', text: '#FFFFFF', label: 'Limited Edition' },
    'sale': { bg: '#F44336', text: '#FFFFFF', label: 'Sale' },
    'featured': { bg: '#E91E63', text: '#FFFFFF', label: 'Featured' }
  };
  return tagColors[tag] || null;
};

const Quick = () => {
  const [categories, setCategories] = useState([]);
  const [storeClose, setStoreClose] = useState(0);
  const [counts, setCounts] = useState({});
  const [totalAmount, setTotalAmount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedName, setSelectedName] = useState(null);
  const [selectedVideoUrl, setSelectedVideoUrl] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [cartItems, setCartItems] = useState([]);
  const [cartCount, setCartCount] = useState(0);
  const [discountvalue, setDiscountvalue] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [discountTotal, setDiscountTotal] = useState();
  const [nonDiscountTotal, setNonDiscountTotal] = useState();
  const [showButton, setShowButton] = useState(false);
  const [showCartSidebar, setShowCartSidebar] = useState(false);
  const [showCategorySidebar, setShowCategorySidebar] = useState(false);
  const [isHeaderFixed, setIsHeaderFixed] = useState(false);
  const [collapsedCategories, setCollapsedCategories] = useState({});
  const location = useLocation();
  const selectedCategory = location.state?.selectedCategory;
  const [selectedVideo, setSelectedVideo] = useState(null);
  const sectionRefs = useRef({});
  const headerRef = useRef(null);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const qtyCount = Object.values(counts).reduce((acc, count) => acc + count, 0);
  const discountRate = Math.round(discountvalue);
  const discountAmount = (discountTotal * discountRate) / 100;
  const finalAmount = discountTotal - discountAmount + nonDiscountTotal;

  // Toggle category collapse
  const toggleCategory = (categoryId) => {
    setCollapsedCategories(prev => ({
      ...prev,
      [categoryId]: !prev[categoryId]
    }));
  };

  // Handle sticky header - appears only after scrolling past the main header
  useEffect(() => {
    const handleScroll = () => {
      const mainHeader = document.querySelector('.main-header-white-bg');
      const mainHeaderHeight = mainHeader ? mainHeader.offsetHeight : 80;
      const minOrderBanner = document.querySelector('.minimum-order');
      const bannerHeight = minOrderBanner ? minOrderBanner.offsetHeight : 40;
      const scrollThreshold = mainHeaderHeight + bannerHeight;

      if (window.pageYOffset > scrollThreshold) {
        setIsHeaderFixed(true);
      } else {
        setIsHeaderFixed(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (!selectedCategory) return;
    const scrollToCategory = () => {
      const section = sectionRefs.current[selectedCategory];
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        setTimeout(scrollToCategory, 100);
      }
    };
    scrollToCategory();
  }, [selectedCategory]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const count = parseInt(localStorage.getItem("cartCount")) || 0;
    setCartCount(count);
    const handleStorageChange = () => {
      const count = parseInt(localStorage.getItem("cartCount")) || 0;
      setCartCount(count);
      const items = JSON.parse(localStorage.getItem("cartItems")) || [];
      setCartItems(items);
    };
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const fetchCartItems = () => {
    const items = JSON.parse(localStorage.getItem("cartItems")) || [];
    setCartItems(items);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}quick_buy.php`);
        const { body } = response.data;

        const initialCounts = body.category
          .flatMap((category) =>
            category.product.map((product) => ({
              product_id: product.product_id,
              count: parseInt(localStorage.getItem(`count_${product.product_id}`)) || 0,
            }))
          )
          .reduce((acc, { product_id, count }) => {
            acc[product_id] = count;
            return acc;
          }, {});

        setCategories(body.category || []);
        setDiscountvalue(body.discount_value[0]?.discount_value || []);
        setStoreClose(Number(body.store_close));
        setCounts(initialCounts);
        fetchCartItems();
      } catch (error) {
        console.error("There was an error fetching the data!", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const handleStorageChange = () => {
      fetchCartItems();
    };
    window.addEventListener("storage", handleStorageChange);
    const handleCartUpdated = () => {
      fetchCartItems();
    };
    window.addEventListener("cartUpdated", handleCartUpdated);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("cartUpdated", handleCartUpdated);
    };
  }, []);

  const updateTotals = useCallback(
    (counts) => {
      let discountTotal = 0;
      let nonDiscountTotal = 0;
      categories.forEach((category) => {
        category.product.forEach((product) => {
          const count = counts[product.product_id] || 0;
          const price = parseFloat(product.oldprice.replace(/[^\d.-]/g, ""));
          if (!isNaN(price)) {
            if (category.non_discount === "0") {
              discountTotal += count * price;
            } else {
              nonDiscountTotal += count * price;
            }
          }
        });
      });
      setTotalAmount(discountTotal + nonDiscountTotal);
      setDiscountTotal(discountTotal);
      setNonDiscountTotal(nonDiscountTotal);
    },
    [categories]
  );

  useEffect(() => {
    updateTotals(counts);
  }, [counts, updateTotals]);

  const handleIncrement = (product_id, product) => {
    const newCounts = {
      ...counts,
      [product_id]: (counts[product_id] || 0) + 1,
    };
    setCounts(newCounts);
    saveCountsToLocalStorage(newCounts);
  };

  const handleDecrement = (product_id) => {
    const newCounts = {
      ...counts,
      [product_id]: Math.max((counts[product_id] || 0) - 1, 0),
    };
    setCounts(newCounts);
    saveCountsToLocalStorage(newCounts);
  };

  const handleQuantityChange = (product_id, value) => {
    let newQuantity = parseInt(value);
    if (isNaN(newQuantity)) newQuantity = 0;
    if (newQuantity < 0) newQuantity = 0;
    const newCounts = {
      ...counts,
      [product_id]: newQuantity,
    };
    setCounts(newCounts);
    saveCountsToLocalStorage(newCounts);
  };

  const saveCountsToLocalStorage = (counts) => {
    Object.entries(counts).forEach(([product_id, count]) => {
      localStorage.setItem(`count_${product_id}`, count);
    });
    const addedItems = categories
      .flatMap((category) =>
        category.product.map((product) => ({
          ...product,
          count: counts[product.product_id] || 0,
          category_id: category.category_id,
          is_non_discount: product.is_non_discount,
        }))
      )
      .filter((item) => item.count > 0);
    localStorage.setItem("cartItems", JSON.stringify(addedItems));
    const totalUniqueProductCount = Object.keys(counts).filter(
      (key) => counts[key] > 0
    ).length;
    localStorage.setItem("cartCount", totalUniqueProductCount);
    setCartItems(addedItems);
    setCartCount(totalUniqueProductCount);
    window.dispatchEvent(new Event("storage"));
    window.dispatchEvent(new Event("cartUpdated"));
  };

  // Function to extract YouTube embed URL from various YouTube URL formats
  const getYouTubeEmbedUrl = (youtubeUrl) => {
    if (!youtubeUrl) return null;

    const patterns = [
      /(?:youtube\.com\/watch\?v=)([a-zA-Z0-9_-]+)/,
      /(?:youtu\.be\/)([a-zA-Z0-9_-]+)/,
      /(?:youtube\.com\/shorts\/)([a-zA-Z0-9_-]+)/,
      /(?:youtube\.com\/embed\/)([a-zA-Z0-9_-]+)/
    ];

    for (const pattern of patterns) {
      const match = youtubeUrl.match(pattern);
      if (match && match[1]) {
        return `https://www.youtube.com/embed/${match[1]}`;
      }
    }
    return null;
  };

  const handleImageClick = (imageSrc, name) => {
    setSelectedImage(imageSrc);
    setSelectedName(name);
    setSelectedVideoUrl(null);
    setSelectedVideo(null);
    setShowModal(true);
  };

  const handleVideoClick = (youtubeUrl, imageSrc, name) => {
    const embedUrl = getYouTubeEmbedUrl(youtubeUrl);
    setSelectedVideoUrl(embedUrl);
    setSelectedVideo(embedUrl);
    setSelectedImage(imageSrc);
    setSelectedName(name);
    setShowModal(true);
  };

  const clearSearch = () => {
    setSearchQuery("");
  };

  const handleCartIconClick = () => {
    setShowCartSidebar(true);
  };

  const closeCartSidebar = () => {
    setShowCartSidebar(false);
  };

  const toggleCategorySidebar = () => {
    setShowCategorySidebar(!showCategorySidebar);
  };

  const closeCategorySidebar = () => {
    setShowCategorySidebar(false);
  };

  const scrollToCategory = (categoryName) => {
    setShowCategorySidebar(false);
    const section = sectionRefs.current[categoryName];
    if (section) {
      const floatingHeader = document.querySelector('.floating-header');
      const headerHeight = floatingHeader ? floatingHeader.offsetHeight : 80;
      const sectionRect = section.getBoundingClientRect();
      const absoluteSectionTop = sectionRect.top + window.pageYOffset;
      const offset = headerHeight + 15;
      const scrollPosition = absoluteSectionTop - offset;
      window.scrollTo({
        top: scrollPosition,
        behavior: 'smooth'
      });
    }
  };

  const handleRemoveItem = (productId) => {
    const newCounts = { ...counts, [productId]: 0 };
    setCounts(newCounts);
    saveCountsToLocalStorage(newCounts);
  };

  const navigate = useNavigate();
  const handleProceedToCheckout = () => {
    setShowCartSidebar(false);
    navigate('/cart')
  };

  // Filter products based on search query
  const filteredCategories = categories
    .map((category) => {
      const filteredProducts = category.product.filter((product) =>
        product.product_name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      return {
        ...category,
        product: filteredProducts,
      };
    })
    .filter((category) => category.product.length > 0);

  if (isLoading) {
    return <CrackersLoader />;
  }

  return (
    <div className="quick-bottom-gap">
      <Header />

      <h5 className="minimum-order">Minimum Order Tamilnadu Rs:3000 and Other States Rs:5000</h5>

      {/* Combined Floating Header - Search + Order Summary + Cart Icon */}
      <div ref={headerRef} className={`floating-header ${isHeaderFixed ? 'fixed' : ''}`}>
        <div className="floating-header-content">
          <button
            className="category-toggle-btn"
            onClick={toggleCategorySidebar}
            aria-label="Toggle Categories"
          >
            <FaBars />
            <span className="menu-text">Menu</span>
          </button>

          <div className="floating-search">
            <i className="fas fa-search search-icon"></i>
            <input
              type="text"
              className="floating-search-input"
              placeholder="Search products..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              autoComplete="off"
            />
            {searchQuery && (
              <button className="floating-search-clear" onClick={clearSearch}>
                <i className="fas fa-times-circle"></i>
              </button>
            )}
          </div>

          <div className="floating-summary">
            <div className="summary-item">
              <span className="summary-label">Order Total :</span>
              <span className="summary-value">₹ {roundToNearestRupee(totalAmount)}</span>
            </div>
            <div className="summary-item">
              <span className="summary-label">Discount ({discountRate}%) :</span>
              <span className="summary-value discount">-₹ {roundToNearestRupee(discountAmount)}</span>
            </div>
            <div className="summary-item">
              <span className="summary-label">Total Qty :</span>
              <span className="summary-value">{qtyCount}</span>
            </div>
            <div className="summary-item">
              <span className="summary-label">Final Amount :</span>
              <span className="summary-value final">₹ {roundToNearestRupee(finalAmount)}</span>
            </div>
          </div>

          <div className="floating-cart" onClick={handleCartIconClick}>
            <i className="bi bi-cart"></i>
            {cartCount > 0 && <span className="cart-badge-floating">{cartCount}</span>}
          </div>
        </div>
      </div>

      {/* Category Sidebar */}
      {showCategorySidebar && (
        <>
          <div className="category-sidebar-overlay" onClick={closeCategorySidebar}></div>
          <div className="category-sidebar">
            <div className="category-sidebar-header">
              <h5>Categories</h5>
              <button className="close-category-btn" onClick={closeCategorySidebar}>
                <FaTimes />
              </button>
            </div>
            <div className="category-sidebar-body">
              {categories.map((category) => (
                <div
                  key={category.category_id}
                  className="category-sidebar-item"
                  onClick={() => scrollToCategory(category.category_name)}
                >
                  <span className="category-sidebar-icon">
                    <i className="bi bi-tag"></i>
                  </span>
                  <span className="category-sidebar-name">{category.category_name}</span>
                  <span className="category-sidebar-count">
                    {category.product.length}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </>
      )}

      {/* Spacer for fixed header */}
      <div className={`header-spacer ${isHeaderFixed ? 'visible' : ''}`}></div>

      {/* Product Grid Layout */}
      <Container fluid className="product-grid-container">
        {filteredCategories.length > 0 ? (
          filteredCategories.map((category) => {
            const isCollapsed = collapsedCategories[category.category_id] || false;
            const productCount = category.product.length;

            return (
              <div key={category.category_id} className="category-section">
                <div
                  className="category-header-wrapper"
                  ref={(el) => {
                    sectionRefs.current[category.category_name] = el;
                  }}
                >
                  <div
                    className="category-title-container"
                    onClick={() => toggleCategory(category.category_id)}
                  >
                    <h5 className="category-title">
                      <span className="category-title-text">{category.category_name}</span>
                      <span className="category-title-right">
                        <span className="category-product-count">{productCount} items</span>
                        <span className="category-toggle-icon">
                          {isCollapsed ? <FaChevronDown /> : <FaChevronUp />}
                        </span>
                      </span>
                    </h5>
                  </div>
                </div>
                <div className={`category-products-wrapper ${isCollapsed ? 'collapsed' : ''}`}>
                  <div className="product-grid">
                    {category.product.map((product) => {
                      const roundedOldPrice = product.oldprice ? roundToNearestRupee(parseFloat(product.oldprice.replace(/[^\d.-]/g, ""))) : 0;
                      const roundedPrice = product.price ? roundToNearestRupee(parseFloat(product.price.replace(/[^\d.-]/g, ""))) : 0;
                      const isDiscounted = parseInt(category.non_discount, 10) === 0;
                      const displayPrice = isDiscounted ? roundedPrice : roundedOldPrice;
                      const originalPrice = isDiscounted ? roundedOldPrice : null;
                      const currentCount = counts[product.product_id] || 0;

                      // Get tag information
                      const tagInfo = product.tag ? getTagColor(product.tag) : null;

                      return (
                        <div key={product.product_id} className="product-card">
                          {/* Tag Badge - Top Right (Both Desktop & Mobile) */}
                          {tagInfo && (
                            <span
                              className="product-tag-badge"
                              style={{
                                backgroundColor: tagInfo.bg,
                                color: tagInfo.text
                              }}
                            >
                              {tagInfo.label}
                            </span>
                          )}

                          {/* Image Section - Left */}
                          <div className="image-column">
                            <div
                              className="product-image-wrapper"
                              onClick={() => handleImageClick(product.image, product.product_name)}
                            >
                              <img
                                src={product.image}
                                alt={product.product_name}
                                className="product-card-image"
                                loading="lazy"
                              />
                            </div>
                            <div>
                              {product.youtube_url && (
                                <span
                                  className="youtube-play-badge"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleVideoClick(product.youtube_url, product.image, product.product_name);
                                  }}
                                >
                                  <FaYoutube className="youtube-icon" /> Watch Video
                                </span>
                              )}
                            </div>
                          </div>

                          {/* Product Details - Right */}
                          <div className="product-card-body">
                            <h6 className="product-card-title">{product.product_name}</h6>

                            <div className="product-card-body-inside">
                              <div>
                                {/* Price Section */}
                                <div className="product-card-price">
                                  {isDiscounted ? (
                                    <>
                                      <span className="grid-price-label">Price:</span>
                                      <span className="old-price">₹{originalPrice}</span>
                                      <span className="new-price">₹{displayPrice}</span>
                                    </>
                                  ) : (
                                    <span className="new-price">₹{displayPrice}</span>
                                  )}
                                </div>
                                {/* <div className="product-card-price">
                                  <span className="qty-badge">
                                    📦 {product.qty_per_box || "N/A"}
                                  </span>
                                </div> */}
                              </div>
                            </div>

                            {/* Quantity Controls */}
                            {storeClose === 0 && (
                              <div className="quantity-controls">
                                <button
                                  className="qty-btn"
                                  onClick={() => handleDecrement(product.product_id)}
                                >
                                  -
                                </button>
                                <input
                                  type="text"
                                  inputMode="numeric"
                                  pattern="[0-9]*"
                                  className="qty-input"
                                  value={currentCount}
                                  onChange={(e) => handleQuantityChange(product.product_id, e.target.value)}
                                  onClick={(e) => e.target.select()}
                                />
                                <button
                                  className="qty-btn"
                                  onClick={() => handleIncrement(product.product_id, product)}
                                >
                                  +
                                </button>
                              </div>
                            )}
                            <div className="grid-product-total">
                              {currentCount > 0 && (
                                <span className="item-total">
                                  ₹ {roundToNearestRupee(currentCount * displayPrice)}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="no-products-found">
            <i className="bi bi-search"></i>
            <p>No products found matching "{searchQuery}"</p>
            <small>Try a different search term</small>
          </div>
        )}
      </Container>

      {/* Cart Sidebar */}
      {showCartSidebar && (
        <>
          <div className="cart-sidebar-overlay" onClick={closeCartSidebar}></div>
          <div className="cart-sidebar">
            <div className="cart-sidebar-header">
              <h5>Your Cart</h5>
              <button className="close-cart-btn" onClick={closeCartSidebar}>
                <FaTimes />
              </button>
            </div>
            <div className="cart-sidebar-body">
              {cartItems.length === 0 ? (
                <div className="empty-cart">
                  <i className="bi bi-cart"></i>
                  <p>Your cart is empty</p>
                </div>
              ) : (
                <>
                  {cartItems.map((item) => {
                    const isNonDiscount = parseInt(item.is_non_discount, 10) === 1;
                    const roundedOldPrice = item.oldprice ? roundToNearestRupee(parseFloat(item.oldprice.replace(/[^\d.-]/g, ""))) : 0;
                    const roundedPrice = item.price ? roundToNearestRupee(parseFloat(item.price.replace(/[^\d.-]/g, ""))) : 0;
                    const displayPrice = isNonDiscount ? roundedOldPrice : roundedPrice;
                    const originalPrice = isNonDiscount ? null : roundedOldPrice;
                    const itemTotal = roundToNearestRupee(item.count * displayPrice);

                    return (
                      <div key={item.product_id} className="cart-sidebar-item">
                        <img src={item.image} alt={item.product_name} className="cart-item-img" />
                        <div className="cart-item-details">
                          <div className="cart-item-name">{item.product_name}</div>
                          <div className="cart-item-price">
                            {isNonDiscount ? (
                              <span className="current-price">₹{displayPrice}</span>
                            ) : (
                              <>
                                <del className="old-price">₹{originalPrice}</del>
                                <span className="current-price">₹{displayPrice}</span>
                              </>
                            )}
                            <span className="cart-item-qty">× {item.count}</span>
                          </div>
                          <div className="cart-item-total">Total: ₹{itemTotal}</div>
                        </div>
                        <div className="cart-item-actions">
                          <button
                            onClick={() => handleQuantityChange(item.product_id, item.count - 1)}
                            className="cart-qty-btn"
                            aria-label="Decrease quantity"
                          >
                            -
                          </button>
                          <span className="cart-qty-value">{item.count}</span>
                          <button
                            onClick={() => handleQuantityChange(item.product_id, item.count + 1)}
                            className="cart-qty-btn"
                            aria-label="Increase quantity"
                          >
                            +
                          </button>
                          <button
                            onClick={() => handleRemoveItem(item.product_id)}
                            className="cart-remove-btn"
                            aria-label="Remove item"
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </>
              )}
            </div>
            <div className="cart-sidebar-footer">
              <div className="cart-summary">
                <div className="cart-summary-row">
                  <span>Subtotal :</span>
                  <span>₹ {roundToNearestRupee(totalAmount)}</span>
                </div>
                <div className="cart-summary-row discount">
                  <span>Discount ({discountRate}%) :</span>
                  <span>-₹ {roundToNearestRupee(discountAmount)}</span>
                </div>
                <div className="cart-summary-row total">
                  <span>Total :</span>
                  <span>₹ {roundToNearestRupee(finalAmount)}</span>
                </div>
              </div>
              <button className="checkout-btn" onClick={handleProceedToCheckout}>
                Proceed to Checkout
              </button>
            </div>
          </div>
        </>
      )}

      {/* Mobile Bottom Floating Bar */}
      <div className="mobile-bottom-bar">
        <div className="mobile-bottom-info">
          <div className="mobile-bottom-row">
            <span className="label">Discount</span>
            <span className="value discount">-₹{roundToNearestRupee(discountAmount)}</span>
          </div>
          <div className="mobile-bottom-row">
            <span className="label">Total Qty</span>
            <span className="value qty">{qtyCount}</span>
          </div>
          <div className="mobile-bottom-row">
            <span className="label">Total Amount</span>
            <span className="value total">₹{roundToNearestRupee(finalAmount)}</span>
          </div>
        </div>
        <div className="mobile-bottom-cart" onClick={handleCartIconClick}>
          <i className="bi bi-cart"></i>
          {cartCount > 0 && <span className="mobile-bottom-badge">{cartCount}</span>}
        </div>
      </div>

      {/* Modal for Image/Video */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered className="product-modal">
        <Modal.Header closeButton className="modal-header-enhanced">
          <Modal.Title>{selectedName}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body-enhanced">
          {selectedVideo ? (
            <div className="video-container">
              <iframe
                src={selectedVideo}
                title="YouTube video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          ) : (
            <div className="image-container">
              <img src={selectedImage} alt="Selected" className="modal-image" />
            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* Scroll to Top Button */}
      {showButton && (
        <button className="scroll-to-top1" onClick={scrollToTop}>
          <FaArrowUp />
        </button>
      )}
    </div>
  );
};

export default Quick;